<template>
  <b-row class="mt-2">
    <b-col>
      <sector />
    </b-col>
    <b-col>
      <country />
    </b-col>
    <b-col>
      <city />
    </b-col>
    <b-col
      class="text-center"
      cols="12"
    >
      <b-button
        variant="primary"
        @click="filterAction"
      >
        <FeatherIcon icon="FilterIcon" /> Filtrele
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import Sector from '@/views/Customers/FilterData/Sector.vue'
import Country from '@/views/Customers/FilterData/Country.vue'
import City from '@/views/Customers/FilterData/City.vue'

export default {
  name: 'FilterData',
  components: {
    BRow,
    BCol,
    BButton,
    Sector,
    Country,
    City,
  },
  props: {
    filterAction: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
